import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import React, { PureComponent } from 'react';

import styles from './styles';

export type CharacterCounterProps = {
  onSubmit?: Function;
  label?: string;
  helperText?: string;
  onChange?: Function;
  limits: number;
  minimum: number;
  name?: string;
  value: any;
  error?: boolean;
  singleSpace?: boolean;
  classes: any;
  ref?: any;
  onFocus?: any;
  id?: any;
  disabled?: boolean;
  placeholder?: string;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
};

interface IState {
  comment: string;
  minimum: number;
}

class CharacterCounter extends PureComponent<CharacterCounterProps, IState> {
  private charactersLimit = this.props.limits;
  private characterMinimum = this.props.minimum;

  constructor(props: CharacterCounterProps) {
    super(props);

    this.state = {
      comment: '',
      minimum: this.characterMinimum,
    };
  }

  handleChange = (e: any) => {
    const { onChange, singleSpace } = this.props;
    let { value } = e.target;

    if (singleSpace) {
      value = value.replace(/  +/g, ' ');
      e.target.value = value;
    }

    this.setState({
      comment: e.target.value,
    });

    onChange(e);
  };

  componentDidMount() {
    const { value } = this.props;
    const comment = value ? value.toString() : '';

    this.setState({
      comment,
    });
  }

  componentDidUpdate(prevProps: CharacterCounterProps) {
    const { value } = this.props;

    if (prevProps.value !== value) {
      const comment = value ? value.toString() : '';

      this.setState({
        comment,
      });
    }
  }

  render() {
    const { classes, onFocus, id } = this.props;
    const { comment } = this.state;
    const characterCount = comment.length;

    return (
      <div className={classes.commentFormClass}>
        <div className={classes.commentFormInputFieldClass}>
          <TextField
            id={id}
            multiline={true}
            fullWidth={true}
            name={this.props.name}
            error={this.props.error ? this.props.error : false}
            label={
              <div className={classes.labelContainerClass}>
                <div>{this.props.label}</div>
                <div>
                  <Chip label={`${characterCount}/${this.charactersLimit}`} size='small' color='secondary' variant='outlined' />
                </div>
              </div>
            }
            helperText={this.props.helperText}
            inputProps={{ maxLength: this.charactersLimit }}
            InputProps={{ rows: 3, disableUnderline: true, maxRows: 10 }}
            InputLabelProps={{ shrink: true }}
            placeholder={this.props.placeholder ? this.props.placeholder : ''}
            value={this.props.value}
            onChange={this.handleChange}
            onFocus={onFocus}
            disabled={this.props.disabled}
            onBlur={this.props.onBlur}
          />
        </div>
      </div>
    );
  }
}

export default styles(CharacterCounter);
